module.exports = __webpack_public_path__ + "static/img/ovo.0e1df2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/ovo.png
// module id = VIzQ
// module chunks = 0